export default "__VITE_ASSET__C7vx6HIG__"